import React, { useEffect, useState } from 'react';
import { api, AED } from '../lib/api';

export default function Retention() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/retention').then(r => setData(r.data));
  }, []);

  if (!data) return <div className="p-10">Loading…</div>;

  return (
    <div className="py-6 max-w-5xl mx-auto space-y-6" data-testid="retention-page">
      <div>
        <div className="overline">Compliance & finance</div>
        <h1 className="font-serif text-4xl">Retention tracker</h1>
        <p className="text-slate-600 mt-2">Retention amounts held from vendor invoices (usually 5-10% for 6-12 months after handover).</p>
      </div>

      <div className="glass p-6">
        <div className="overline">Total retention held</div>
        <div className="font-serif text-4xl mt-2 text-amber-700">{AED(data.total_retention_aed)}</div>
      </div>

      <div className="glass p-6">
        <div className="font-serif text-2xl mb-4">By invoice</div>
        <table className="w-full text-sm">
          <thead>
            <tr className="overline text-left border-b border-slate-200/60">
              <th className="py-2">Invoice</th><th>Vendor</th><th>Description</th><th className="text-right">Retention (AED)</th>
            </tr>
          </thead>
          <tbody>
            {data.invoices.map(inv => (
              <tr key={inv.id} className="border-b border-slate-100/70">
                <td className="py-3 font-mono text-xs">{inv.invoice_number}</td>
                <td className="text-xs">{data.vendors[inv.vendor_id]?.company || '—'}</td>
                <td className="max-w-md truncate">{inv.description}</td>
                <td className="text-right font-semibold">{AED(inv.retention_held_aed)}</td>
              </tr>
            ))}
            {data.invoices.length === 0 && <tr><td colSpan={4} className="py-8 text-center text-slate-400">No retention held.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
